"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _Nugget2 = _interopRequireDefault(require("../Nugget"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var TerminNugget = /*#__PURE__*/function (_Nugget) {
  (0, _inherits2["default"])(TerminNugget, _Nugget);

  var _super = _createSuper(TerminNugget);

  // nothing special about this nugget so far
  function TerminNugget(json) {
    var _this;

    (0, _classCallCheck2["default"])(this, TerminNugget);
    _this = _super.call(this, json);
    _this.localName = json.localName;
    _this.calUrl = json.url;
    _this.icon = json.icon;
    _this.info = json.info;
    _this.title = json.title;
    _this.show_title = json.show_title;
    _this.start = json.start;
    _this.end = json.end;
    _this.location = json.location;
    return _this;
  }

  return TerminNugget;
}(_Nugget2["default"]);

TerminNugget.CLASS = 'termin';
var _default = TerminNugget;
exports["default"] = _default;